import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EarlyReport from "./Early_going";
import WeekEarlyGoing from "./weekly_early_going_report";
import MonthEarlyGoing from "./monthly_early_going";

/**
 * Wraps the Day Wise, Weekly and Monthly early going reports as tabs that toggle
 * with state — all stay mounted, so switching is instant with no route change
 * and no reload.
 */
const EarlyGoingReportTabs = () => {
  const [activeTab, setActiveTab] = useState("day");

  return (
    <div className="container-fluid mt-4">
      <ToastContainer position="bottom-right" />

      {/* Tabs */}
      <div className="mb-3 d-flex flex-wrap" style={{ gap: "10px" }}>
        <button
          type="button"
          className={`btn btn-sm ${activeTab === "day" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setActiveTab("day")}
        >
          Day Wise Early Going Report
        </button>
        <button
          type="button"
          className={`btn btn-sm ${activeTab === "week" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setActiveTab("week")}
        >
          Weekly Wise Early Going
        </button>
        <button
          type="button"
          className={`btn btn-sm ${activeTab === "month" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setActiveTab("month")}
        >
          Monthly Early Going
        </button>
      </div>

      {/* All stay mounted; only the active one is shown */}
      <div style={{ display: activeTab === "day" ? "block" : "none" }}>
        <EarlyReport />
      </div>
      <div style={{ display: activeTab === "week" ? "block" : "none" }}>
        <WeekEarlyGoing />
      </div>
      <div style={{ display: activeTab === "month" ? "block" : "none" }}>
        <MonthEarlyGoing />
      </div>
    </div>
  );
};

export default EarlyGoingReportTabs;
